/** Small shared presentational pieces: chips, priority marks, copy button. */

import { useState } from 'react'
import { renderMarkdown } from '../lib/markdown.js'

/** Priority mark, coloured by level. */
export function Priority({ value }) {
  return (
    <span className={`prio ${value}`} title={`priority ${value}`}>
      {value.toUpperCase()}
    </span>
  )
}

/** A rounded label chip. `kind` selects the colour treatment. */
export function Chip({ children, kind = '', title }) {
  return (
    <span className={`chip ${kind}`.trim()} title={title}>
      {children}
    </span>
  )
}

/** Rendered markdown block. Input is escaped inside `renderMarkdown`. */
export function Markdown({ source }) {
  return <div className="md" dangerouslySetInnerHTML={{ __html: renderMarkdown(source) }} />
}

/**
 * Copy-to-clipboard button with a transient confirmation.
 *
 * Falls back to a hidden textarea + `execCommand` when the async clipboard API
 * is unavailable (non-secure origins).
 */
export function CopyButton({ text, label = 'Copy' }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        const area = document.createElement('textarea')
        area.value = text
        area.style.position = 'fixed'
        area.style.opacity = '0'
        document.body.appendChild(area)
        area.select()
        document.execCommand('copy')
        document.body.removeChild(area)
      }
      setCopied(true)
      setTimeout(() => setCopied(false), 1400)
    } catch {
      setCopied(false)
    }
  }

  return (
    <button type="button" className="btn sm" onClick={copy}>
      {copied ? 'Copied' : label}
    </button>
  )
}
